import Box from '@zenbusiness/zui/Box';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import { styled } from '@zenbusiness/zui/styles';

export const DialogContentStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main
}));

export const RadioCardStyled = styled(FormControlLabel)(
  ({ theme, selected }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1.5),
    border: '2px solid',
    borderColor: selected ? theme.palette.info.main : theme.palette.border.main,
    cursor: 'pointer',
    margin: 0
  }),
  { shouldForwardProp: (prop) => prop !== 'selected' }
);
